interface Props {
  [key: string]: any
}
function HomeThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M0.828857 9.9032L2.8009 7.9194M2.8009 7.9194L9.70304 0.976074L16.6052 7.9194M2.8009 7.9194H16.6052M2.8009 7.9194V17.8384C2.8009 18.1015 2.90478 18.3538 3.0897 18.5398C3.27461 18.7258 3.52541 18.8303 3.78692 18.8303H6.74498M2.8009 7.9194L6.74498 18.8303M16.6052 7.9194L18.5772 9.9032M16.6052 7.9194V17.8384C16.6052 18.1015 16.5013 18.3538 16.3164 18.5398C16.1315 18.7258 15.8807 18.8303 15.6192 18.8303H12.6611M16.6052 7.9194L12.6611 18.8303M6.74498 18.8303C7.00649 18.8303 7.25729 18.7258 7.4422 18.5398C7.62712 18.3538 7.731 18.1015 7.731 17.8384V13.8708C7.731 13.6077 7.83488 13.3555 8.0198 13.1694C8.20471 12.9834 8.45551 12.8789 8.71702 12.8789H10.6891C10.9506 12.8789 11.2014 12.9834 11.3863 13.1694C11.5712 13.3555 11.6751 13.6077 11.6751 13.8708V17.8384C11.6751 18.1015 11.779 18.3538 11.9639 18.5398C12.1488 18.7258 12.3996 18.8303 12.6611 18.8303M6.74498 18.8303H12.6611"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default HomeThinIcon
